import { atom } from "recoil"

const isTabletFullScreen = atom({
  key: "isTabletFullScreen",
  default: false
})

const fullscreenState = {
  isTabletFullScreen
}

export default fullscreenState
